import axios, { AxiosRequestConfig } from 'axios';
import axiosBetterStacktrace from 'axios-better-stacktrace';
import { setupCache } from 'axios-cache-adapter';
import urljoin from 'url-join';

// Create `axios-cache-adapter` instance
const cache = setupCache({
    maxAge: 0, // Control cache age on each request
    exclude: {
        // Don't exclude requests with query parameters
        query: false
    }
});

const config: AxiosRequestConfig = {
    baseURL: urljoin(process.env.VUE_APP_SHOPIFY_APP_URL, '/api'),
    responseType: 'json',
    adapter: cache.adapter,
    withCredentials: true
};

const axiosInstance = axios.create(config);
axiosBetterStacktrace(axiosInstance);

export default axiosInstance;
